import React from 'react';
import { useAuthContext } from 'react-oauth2-code-pkce';
import { MESSAGES } from '@translations/labels';
import { splitLines } from '@utils/format/text';
import SVGIconBotSad from '@svg/IconBotSad';
import unAuthorizeStyles from './unAuthorizeStyles';

const loginLabels = { ...MESSAGES.login };
const headerLabels = { ...MESSAGES.header };
const sentences = splitLines(loginLabels.unAuthorizedContent);

const UnAuthorizePage = () => {
  const { logOut } = useAuthContext();

  return (
    <div className="un-authorize-content centered-flex overflow-y-auto">
      <SVGIconBotSad className="svg-bot" width="334px" />
      <h5 className="title uppercase">{loginLabels.unauthorized}</h5>
      {sentences.map((sentence, index) => (
        <p key={`text-${index}`}>{sentence}</p>
      ))}
      <button onClick={() => logOut()} className="link-secondary block" style={{ marginTop: '16px', cursor: 'pointer', background: 'none', border: 'none', fontSize: 'inherit' }}>
        {headerLabels.logout}
      </button>
      <style jsx>{unAuthorizeStyles}</style>
    </div>
  );
};

export { UnAuthorizePage };
